import { DEFAULT_NOTIFICATION_SETTINGS } from "@/consts";
import type {
  InputMaybe,
  NotificationSettingsInput,
  Scalars,
} from "@/graphql/generated-types";
import { useAuthStore } from "@/stores/authStore";

type DefaultGetter = () => NotificationSettingsInput;

type APIData = {
  id?: InputMaybe<string> | undefined;
  notificationSettings?: {
    status: boolean;
    reminderFirst?: number | null;
    reminderSecond?: number | null;
    triggerWhenCancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
    triggerWhenTimeChange?: InputMaybe<Scalars["Boolean"]["input"]>;
  } | null;
  institution?: {
    id: string;
  };
};

type Item = {
  id?: string | number | null;
};

export default (data: APIData, item: Item, getDefaults: DefaultGetter) => {
  const authStore = useAuthStore();

  let settings: NotificationSettingsInput;
  if (data.notificationSettings) {
    const {
      status,
      reminderFirst,
      reminderSecond,
      triggerWhenCancelled,
      triggerWhenTimeChange,
    } = data.notificationSettings;
    settings = {
      ...getDefaults(),
      status,
      reminderFirst,
      reminderSecond,
      triggerWhenCancelled,
      triggerWhenTimeChange,
    };
  } else if (item.id) {
    settings = {
      ...DEFAULT_NOTIFICATION_SETTINGS,
    };
  } else {
    settings = {
      ...getDefaults(),
    };
  }

  settings.entityId = data.id;
  settings.institution =
    data.institution?.id?.toString() || authStore.institutionId;

  return settings;
};
